/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMlScenarioDto } from '../../models/backend-ml-scenario-dto';

export interface MonitoringScenariosList$Params {
  project?: number;
}

export function monitoringScenariosList(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringScenariosList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMlScenarioDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosList.PATH, 'get');
  if (params) {
    rb.query('project', params.project, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMlScenarioDto>>;
    }),
  );
}

monitoringScenariosList.PATH = '/api/monitoring/scenarios/';
